import * as React from "react";
import { getIntersectionObserverConstructor } from "sb-helpers";
import { Loader } from "../Loader";
const defaultsOptions = {
    rootMargin: "0px",
    threshold: .01
};
/* eslint @typescript-eslint/no-explicit-any: "off" */
export class Img extends React.Component {
    constructor(props) {
        super(props);
        this.update = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.changeLoading(true);
                    this.loadImg();
                    this.observer.disconnect();
                }
            });
        };
        this.refRoot = React.createRef();
        const OBS = getIntersectionObserverConstructor();
        this.observer = new OBS(this.update, Object.assign(Object.assign({}, defaultsOptions), props.lazyOptions));
        this.state = {
            isLoading: false,
            imgStyle: {
                width: this.props.width,
                height: this.props.height
            }
        };
    }
    loadImg() {
        const img = new Image();
        img.onload = this.onLoad.bind(this, img);
        img.onerror = this.onError.bind(this);
        img.src = this.props.src;
        return img;
    }
    getValue(ref, fallback) {
        return ref || fallback;
    }
    onLoad(img) {
        const imgWidth = this.getValue(this.props.width, img.width);
        const imgHeight = this.getValue(this.props.height, img.height);
        this.loadImgStyle(imgWidth, imgHeight, this.props.src);
        this.changeLoading(false);
    }
    onError() {
        const imgWidth = this.props.width;
        const imgHeight = this.props.height;
        this.loadImgStyle(imgWidth, imgHeight, this.props.fallbackSrc);
        this.changeLoading(false);
    }
    loadImgStyle(width, height, imgUrl) {
        this.setState({
            imgStyle: {
                width,
                height,
                backgroundImage: `url("${imgUrl}")`,
            }
        });
    }
    changeLoading(state) {
        this.setState({ isLoading: state });
    }
    componentDidMount() {
        if (this.refRoot.current) {
            this.observer.observe(this.refRoot.current);
        }
    }
    render() {
        return (React.createElement("sb-img", { class: this.props.className, style: this.state.imgStyle, ref: this.refRoot }, this.state.isLoading && React.createElement(Loader, null)));
    }
}
//# sourceMappingURL=Img.js.map